import React from 'react';
import { useQuery } from 'convex/react';
import { useMutation } from '../lib/convex';
import { api } from '../lib/convex';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { SignOut } from '../components/auth/TeacherAuth';

const DebugAuthPage: React.FC = () => {
  const identity = useQuery(api.debugAuth.checkIdentity);
  const clearAuth = useMutation(api.clearAuth.clearMyAuth);

  const handleClearAuth = async () => {
    try {
      const result = await clearAuth();
      alert(result.message);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert('Failed to clear auth');
    }
  };

  return (
    <div className="container max-w-2xl mx-auto px-4 py-8">
      <Card>
        <CardHeader>
          <div className="flex justify-between items-center">
            <CardTitle>Debug Authentication</CardTitle>
            <div className="flex gap-2">
              <Button onClick={handleClearAuth} variant="destructive" size="sm">
                Clear Auth Session
              </Button>
              <SignOut />
            </div>
          </div>
        </CardHeader>
        <CardContent>
          {!identity ? (
            <p>Loading...</p>
          ) : !identity.authenticated ? (
            <p>Not authenticated</p>
          ) : (
            <div className="space-y-2">
              <h3 className="font-bold">Your Identity:</h3>
              <pre className="bg-gray-100 p-4 rounded overflow-auto text-xs">
                {JSON.stringify(identity.identity, null, 2)}
              </pre>
              <div className="mt-4">
                <h3 className="font-bold">Expected values:</h3>
                <p className="text-sm">nickname: <code>Anthony-Jhoiro</code></p>
                <p className="text-sm mt-2">Actual nickname: <code>{identity.identity?.nickname || 'null'}</code></p>
                <p className="text-sm mt-2">Email: <code>{identity.identity?.email || 'null'}</code></p>
                <p className="text-sm mt-2">Username from email: <code>{identity.identity?.email?.split('@')[0] || 'null'}</code></p>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default DebugAuthPage;
